const baseURL = 'https://cachetitosdealgodon.com/';

export default baseURL;
